import React from 'react';
import { ImageOpacitySlider } from './image-opacity-slider';
import { ImageUploadButton } from './image-upload-button';
type ReferenceImageControlsPropsT = {
  backgroundImage: string | null;
  imageOpacity: number;
  onImageSelect: (imageUrl: string) => void;
  onOpacityChange: (opacity: number) => void;
  onRemoveImage: () => void;
};
export function ReferenceImageControls({
  backgroundImage,
  imageOpacity,
  onImageSelect,
  onOpacityChange,
  onRemoveImage
}: ReferenceImageControlsPropsT) {
  if (!backgroundImage) {
    return <ImageUploadButton onImageSelect={onImageSelect} />;
  }
  return <ImageOpacitySlider opacity={imageOpacity} onOpacityChange={onOpacityChange} onRemoveImage={onRemoveImage} />;
}